// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OCOOrderEdit } from '../order-edit/OCOOrderEdit';
import { OrderTypeBase } from './OrderTypeBase';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { BaseSettings } from '../../../Settings/BaseGeneralSettingsWrapper';
import { Enum } from '@shared/utils/Enum';
export class OCOOrderType extends OrderTypeBase {
    constructor() {
        super(OCOOrderEdit, null);
    }
    id() {
        return OrderType.OCO;
    }
    IsSupported(params) {
        const ins = params.instrument;
        const acc = params.account;
        const route = ins.DataCache.Routes.getRouteByName(ins.getRoute());
        const ordType = this.id();
        const tifs = Enum.GetEnumValues(OrderTif);
        let allowedByTif = false;
        if (!isNullOrUndefined(ins) && !isNullOrUndefined(acc) && !isNullOrUndefined(route)) {
            for (const key in tifs) {
                if (route.IsAllowableTif(tifs[key], ordType)) {
                    allowedByTif = true;
                    break;
                }
            }
        }
        return (allowedByTif &&
            // TODO. REfactor. Ugly.
            OrderTypeBase.IsSupported(OrderType[BaseSettings.isUseStopLimitInsteadStop() ? 'StopLimit' : 'Stop'], ins) &&
            OrderTypeBase.IsSupported(OrderType.Limit, ins) &&
            this.checkRuleForAccount(acc, RulesSet.FUNCTION_BINDEDORDERS, ins));
    }
}
